import { getMetadata, getStreams, getAudioDescriptionUrl, getDownloads, getCaptions, getChapters, getTimedEvents, getCompositionMap, getPresentationOptions } from '../../../api/presentation';
import { getOptions, getExtensions } from '../../../api/player';

/**
 * @param {string} presentationId
 * @returns {Promise<PresentationData>}
 */
export async function loadPresentationData(presentationId) {
    const [
        metadata,
        streams,
        audioDescriptionUrl,
        downloads,
        captions,
        chapters,
        timedEvents,
        playerOptions,
        playerExtensions,
        compositionMap,
        presentationOptions
    ] = await Promise.all([
        getMetadata(presentationId),
        getStreams(presentationId),
        getAudioDescriptionUrl(presentationId),
        getDownloads(presentationId),
        getCaptions(presentationId),
        getChapters(presentationId),
        getTimedEvents(presentationId),
        getOptions(presentationId),
        getExtensions(presentationId),
        getCompositionMap(presentationId),
        getPresentationOptions(presentationId)
    ]);

    return {
        metadata,
        streams,
        audioDescriptionUrl,
        downloads,
        captions,
        chapters,
        timedEvents,
        playerOptions,
        playerExtensions,
        compositionMap,
        presentationOptions
    }
}
